// extracted by mini-css-extract-plugin
export var currencyInput = "_mz-1";
export var currencySymbol = "_mz-0";